export default class OrgUnitsJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  tree(params = {}) {
    return this.axiosIns.get('/org-units/tree', { params })
  }
}
